import React, { useState , useEffect} from 'react';
import { FaPlus } from "react-icons/fa6";



const ByobProductCards = ({ product , index , handleAddToTray, trayData }) => {

  const [isActive, setIsActive] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [isKeyboardUser, setIsKeyboardUser] = useState(false)


  useEffect(() => {
    console.log("Card State" , isActive)
  }, [isActive])

  useEffect(() => {
    const handleKeyDown = () => {
      setIsKeyboardUser(true);
    };

    const handleMouseDown = () => {
      setIsKeyboardUser(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);


  const handleGoToProduct = () => {
    // window.location.href = `/products/${product.handle}`;
  }

  const handleCardFocus = () => {
    setIsFocused(true);
  };

  const handleCardBlur = (e) => {
    console.log("Card Blur" , e)
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsFocused(false);
    }
  };
  

  const secondaryImage = product.images[1]?.medium || product.image;

    return (
      <article 
        className="mb-2 col-span-1 md:col-span-3 relative group p-5 md:h-[400px] xl:h-full flex flex-col mt-5" 
        tabIndex="0" role="group"
        onClick={() => handleGoToProduct()} onMouseEnter={() => setIsActive(true)} onMouseLeave={() => setIsActive(false)}
        onFocus={handleCardFocus}
        onBlur={handleCardBlur}
        aria-label={`Product card for ${product.title}`}
        >
        <div 
        className="relative aspect-square w-full flex-shrink-0 h-full"
        role="img"
        aria-label={`product images for ${product.title}`}
        >
          <img 
            src={product.image} 
            alt={`Primary view of ${product.title}`}
            className='w-full h-full object-cover group-hover:opacity-0 transition-all duration-300'
          />
          
          <img 
            src={secondaryImage} 
            alt={`Secondary view of ${product.title}`}
            className='absolute inset-0 w-full h-full hidden md:block object-cover rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300'
          />

          <button 
            onClick={(e) => { 
              e.stopPropagation(); 
              handleAddToTray(product)
            }}  
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                handleAddToTray(product);
              }
            }}
            className={`
              relative top-[-40px] md:top-[-50px] left-[80%] md:left-[83.5%] lg:left-[78.5%]  hover:shadow-xl 
              focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              ease-in-out duration-300 px-[8px] py-2 bg-none  
              text-white rounded-full ${trayData.length === 5 ? 'bg-gray-500' : 'bg-white'}
              ${isKeyboardUser || isActive || isFocused ? 'opacity-100' : 'opacity-100 md:hidden'}
              transition-all duration-300
            `}
            role="button"
            tabIndex="0"
            disabled={trayData.length === 5}
            aria-label={`Add ${product.title} to tray${trayData.length === 5 ? ' (Tray is full)' : ''}`}
            aria-disabled={trayData.length === 5}
          >
            <FaPlus size={20} color={`${trayData.length === 5 ? 'gainsboro' : 'black'}`} className=' border-solid xl:text-2xl'/>
          </button>
        </div>


        
        <div className="text-center mt-4 flex-grow">
          <h3 className="text-[12.96px] text-[#726e75] font-[500] line-clamp-2">{product.title}</h3>
          <p className="text-[12.96px] mt-1" aria-label={`Price: ${product.price}`}>{product.price}</p>
        </div>
      </article>
    )
}

export default ByobProductCards;